export default "__VITE_ASSET__BqvLTSgX__"